import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

// ─── Types ──────────────────────────────────────────────────────────────────

export interface DashboardStats {
  total_jobs: number;
  approved: number;
  rejected: number;
  in_progress: number;
  awaiting_review: number;
}

export interface ReviewQueueStats {
  rejected_count: number;
  manual_review_count: number;
  approved_with_alerts_count: number;
  approved_count: number;
  total: number;
}

// ─── Hook ────────────────────────────────────────────────────────────────────

/**
 * Fetches KPI stats for the dashboard Overview tab header cards.
 * Polls every 30 seconds so the Awaiting Review count stays fresh.
 */
export function useDashboardStats() {
  return useQuery<DashboardStats>({
    queryKey: ['dashboard', 'stats'],
    queryFn: () => api.get<DashboardStats>('/api/v1/jobs/stats'),
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
    staleTime: 15_000,
  });
}

/**
 * Fetches review queue counts for the Needs Review tab badge.
 * Polls every 30 seconds so the badge count stays live.
 */
export function useReviewQueueStats() {
  return useQuery<ReviewQueueStats>({
    queryKey: ['dashboard', 'review-queue-stats'],
    queryFn: () => api.get<ReviewQueueStats>('/api/v1/jobs/review-queue/stats'),
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
    staleTime: 15_000,
  });
}
